import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ContractInstalmentsAnalytics from '@/components/contracts/ContractInstalmentsAnalytics';
import ContractInstalmentsRecords from '@/components/contracts/ContractInstalmentsRecords';
import { Clock } from 'lucide-react';

export default function ContractInstalments() {
    return (
        <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
            <div className="mb-8">
                <div className="flex items-center gap-3 mb-2">
                    <Clock className="h-8 w-8" />
                    <h1 className="text-4xl font-semibold tracking-tight">Contract Instalments</h1>
                </div>
                <p className="text-muted-foreground">Payment schedules for contracts.</p>
            </div>

            <Tabs defaultValue="analytics" className="space-y-6">
                <TabsList>
                    <TabsTrigger value="analytics">Analytics</TabsTrigger>
                    <TabsTrigger value="records">Records</TabsTrigger>
                </TabsList>

                <TabsContent value="analytics">
                    <ContractInstalmentsAnalytics />
                </TabsContent>

                <TabsContent value="records">
                    <ContractInstalmentsRecords />
                </TabsContent>
            </Tabs>
        </div>
    );
}
